import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import Back from "shared/assets/images/svg/back_blue.svg";
import Input from "shared/component/inputFields";
import { useResetPassword } from "auth/resetPassword/reset-password.service";
import { Spinner } from "react-bootstrap";

const ResetPassword = () => {
  const {
    register,
    formState: { errors },
    submit,
    isLoading,
    serverErrors,
  } = useResetPassword();
  const { t } = useTranslation();
  return (
    <div className="resetPassword">
      <div className="container">
        <form
          className="col-lg-5 col-md-6 mx-auto"
          onSubmit={(e) => {
            e.preventDefault();
            submit();
          }}
        >
          <div className="box-reset">
            <div className="header">
              <Link to="/login">
                <img src={Back} alt="back" />
              </Link>
              <h1>{t("login.reset-your-password")}</h1>
            </div>
            <Input
              type="text"
              label={t("login.email")}
              {...register("email")}
              error={errors.email?.message ?? serverErrors['Email']}
            />
            <button type="submit" disabled={isLoading} className="btn-blue text-center d-block w-100">
              <Spinner animation='border' size='sm' hidden={!isLoading} />
              {t("login.send-password")}
            </button>
            <Link className="link" to="/signup">
              {t("login.dont-have-an-account-yet")}
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ResetPassword;
